import { Chip } from '@mui/material'
import {
    AdminPanelSettings as AdminIcon,
    People as PeopleIcon,
    Person as PersonIcon,
    SupervisorAccount as SupervisorIcon,
    Visibility as VisibilityIcon,
} from '@mui/icons-material'

/**
 * Reusable RoleChip component
 * Displays user role with appropriate color and icon
 * 
 * @param {string} role - User role (Admin, HR, Manager, etc.)
 * @param {string} size - Chip size (small, medium)
 * @returns {JSX.Element} Styled chip component
 */
export function RoleChip({ role, size = 'small' }) {
    const config = {
        admin: { color: 'error', icon: <AdminIcon fontSize="small" /> },
        'super admin': { color: 'error', icon: <AdminIcon fontSize="small" /> },
        superadmin: { color: 'error', icon: <AdminIcon fontSize="small" /> },
        'organization admin': { color: 'error', icon: <AdminIcon fontSize="small" /> },
        hr: { color: 'warning', icon: <PeopleIcon fontSize="small" /> },
        'hr manager': { color: 'warning', icon: <PeopleIcon fontSize="small" /> },
        manager: { color: 'info', icon: <SupervisorIcon fontSize="small" /> },
        'department manager': { color: 'info', icon: <SupervisorIcon fontSize="small" /> },
        viewer: { color: 'default', icon: <VisibilityIcon fontSize="small" /> },
        employee: { color: 'primary', icon: <PersonIcon fontSize="small" /> },
    }

    const roleLower = role?.toLowerCase() || ''
    const { color, icon } = config[roleLower] || {
        color: 'default',
        icon: <PersonIcon fontSize="small" />
    }

    return (
        <Chip
            icon={icon}
            label={role}
            color={color}
            size={size}
        />
    )
}
